<template>
  <section id="main">
    <section id="content">
      <div class="allcp-form">
        <div class="row">
          <div class="col-md-12 text-center">
            <img :src="`/static/img/${logo}`" class="gwm-logo" alt="Logo"/>
          </div>
        </div>
        <div class="row">
          <div class="alert alert-danger col-xs-12 adblocker-enabled" v-if="adBlockerEnabled">
            Please disable your AdBlocker and reload this page.
          </div>
          <div class="col-xs-offset-3 col-xs-6 panel panel-default" v-else>
            <div class="panel-body">
              <form method="post" action="/login">
                <div class="form-group">
                  <label>Username</label>
                  <input type="text" class="form-control" v-model="username" placeholder="Username">
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" class="form-control" v-model="password" placeholder="Password">
                </div>
                <div class="form-group">
                  <!--<div class="col-md-4 pull-right">-->
                  <input type="submit" class="btn btn-primary btn-bordered pull-right" id="btnLogin" :disabled="isLoggingOn" @click="login">
                  <!--</div>-->
                </div>
                <input type="hidden" id="redirect" name="redirect" value=""/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <loading :show="isLoggingOn"></loading>

    <alert class="login-error-alert" v-model="showError" placement="top" duration="0" type="danger" width="400px" dismissable>
      <i class="fa fa-exclamation-triangle"></i>
      <strong>Login Error</strong>
      <template v-if="errorMessage">
        <p v-if="errorMessage.includes('locked')">{{ lockedOutErrorMessage }}</p>
        <p v-else>{{ errorMessage }}</p>
      </template>
      <p v-else>If the problem persists, please contact support.</p>
    </alert>

    <iframe name="csp_iframe" src="" sandbox="allow-scripts allow-same-origin"></iframe>
    <form action="" method="POST" target="csp_iframe" name="csp_form">
      <input type="hidden" name="u" :value="username"/>
      <input type="hidden" name="p" :value="password"/>
    </form>
  </section>
</template>

<script>
  import { alert } from 'vue-strap';
  import VueAdBlockDetect from 'vue-adblock-detect';
  import request from 'superagent';
  import Fingerprint2 from 'fingerprintjs2';

  import loading from '../../components/common/Loading.vue';

  export default {
    name: 'login',
    mixins: [VueAdBlockDetect],
    props: {
      logo: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        adBlockerEnabled: false,
        isLoggingOn: false,
        showError: false,
        errorMessage: '',
        lockedOutErrorMessage: 'Your account has been locked out due to too many failed login attempts. Please contact support to unlock you.',
        username: '',
        password: '',
        fingerprint: '',
      };
    },
    components: {
      loading,
      alert,
    },
    beforeMount() {
      this.detectAdBlock().then((adBlockerEnabled) => {
        if (adBlockerEnabled) {
          this.adBlockerEnabled = true;
        } else {
          this.adBlockerEnabled = false;
        }
      });
    },
    mounted() {
      new Fingerprint2().get((result) => {
        this.fingerprint = result;
      });
    },
    methods: {
      login(e) {
        e.preventDefault();
        const self = this;
        self.isLoggingOn = true;
        request.post('/login/')
          .send({ username: self.username })
          .send({ password: self.password })
          .send({ fingerprint: self.fingerprint })
          .set('X-CSRFToken', document.getElementsByName('csrf-token')[0].getAttribute('content'))
          .end((err, res) => {
            if (err || res.body.status === 'false') {
              self.isLoggingOn = false;
              self.errorMessage = err || res.body.message;
              self.showError = true;
            } else {
              const redirect = document.getElementsByName('redirect')[0].getAttribute('value');
              self.isLoggingOn = false;
              window.location = redirect;
            }
          });
      },
    },
  };
</script>

<style>
  .hide {
    display: none;
  }
  .login-error-alert{
    top: 650px !important;
  }
  .panel-body {
    margin: 0 !important;
  }

  iframe {
    visibility: hidden;
  }

  .gwm-logo {
    margin-bottom: 25px;
  }

  .adblocker-enabled {
    text-align: center;
    font-weight: 600;
  }
</style>
